import { useField, useFormikContext } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Button, Heading, Label, Slider } from '@treams/treams-ui';

const Axis = styled(Label)<{ start?: boolean; end?: boolean }>``;

export default function Enps(props: { type: graphql.EngagementType }) {
	const { t } = useTranslation();
	const { localize } = useLocalize();
	const [{ value }, , { setValue }] = useField('answer.index');
	const [loading, setLoading] = useState(false);
	const formik = useFormikContext();

	const titles = props.type.options?.map((option) => localize(option.title!).text);

	return (
		<Box width="100%">
			<Box flexGrow={1} width="100%" maxWidth={670}>
				<Slider
					value={(value ?? 5) / 10}
					fillMode="forwards"
					onChange={(value) => {
						setValue(Math.round(value * 10));
					}}
				/>

				{titles && (
					<>
						<Flex mt={3}>
							<Axis flexGrow={0} flexShrink={0} start>
								{titles[0]}
							</Axis>
							<Box flexGrow={1} flexShrink={1} />
							<Axis flexGrow={0} flexShrink={0} end>
								{titles[titles.length - 1]}
							</Axis>
						</Flex>
						{value !== undefined && (
							<Flex mt={-3} justifyContent="center">
								<Heading>{titles[value]}</Heading>
							</Flex>
						)}
					</>
				)}
			</Box>

			{value !== undefined && (
				<Flex justifyContent="center">
					<Flex mt={4}>
						<Button
							loading={loading}
							title={t('engagement.respond.face.confirm')}
							onClick={async () => {
								setLoading(true);
								await formik.submitForm();
							}}
						/>
					</Flex>
				</Flex>
			)}
		</Box>
	);
}
